const M = globalThis, V = M.ShadowRoot && (M.ShadyCSS === void 0 || M.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, F = Symbol(), Q = /* @__PURE__ */ new WeakMap();
let ct = class {
  constructor(t, e, r) {
    if (this._$cssResult$ = !0, r !== F) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t, this.t = e;
  }
  get styleSheet() {
    let t = this.o;
    const e = this.t;
    if (V && t === void 0) {
      const r = e !== void 0 && e.length === 1;
      r && (t = Q.get(e)), t === void 0 && ((this.o = t = new CSSStyleSheet()).replaceSync(this.cssText), r && Q.set(e, t));
    }
    return t;
  }
  toString() {
    return this.cssText;
  }
};
const ht = (o) => new ct(typeof o == "string" ? o : o + "", void 0, F), mt = (o, ...t) => {
  const e = o.length === 1 ? o[0] : t.reduce(((r, i, n) => r + ((a) => {
    if (a._$cssResult$ === !0) return a.cssText;
    if (typeof a == "number") return a;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + a + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + o[n + 1]), o[0]);
  return new ct(e, o, F);
}, $t = (o, t) => {
  if (V) o.adoptedStyleSheets = t.map(((e) => e instanceof CSSStyleSheet ? e : e.styleSheet));
  else for (const e of t) {
    const r = document.createElement("style"), i = M.litNonce;
    i !== void 0 && r.setAttribute("nonce", i), r.textContent = e.cssText, o.appendChild(r);
  }
}, tt = V ? (o) => o : (o) => o instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const r of t.cssRules) e += r.cssText;
  return ht(e);
})(o) : o;
const { is: yt, defineProperty: _t, getOwnPropertyDescriptor: xt, getOwnPropertyNames: At, getOwnPropertySymbols: Et, getPrototypeOf: Ct } = Object, N = globalThis, et = N.trustedTypes, St = et ? et.emptyScript : "", zt = N.reactiveElementPolyfillSupport, A = (o, t) => o, O = { toAttribute(o, t) {
  switch (t) {
    case Boolean:
      o = o ? St : null;
      break;
    case Object:
    case Array:
      o = o == null ? o : JSON.stringify(o);
  }
  return o;
}, fromAttribute(o, t) {
  let e = o;
  switch (t) {
    case Boolean:
      e = o !== null;
      break;
    case Number:
      e = o === null ? null : Number(o);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(o);
      } catch {
        e = null;
      }
  }
  return e;
} }, J = (o, t) => !yt(o, t), rt = { attribute: !0, type: String, converter: O, reflect: !1, useDefault: !1, hasChanged: J };
Symbol.metadata ??= Symbol("metadata"), N.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
let $ = class extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ??= []).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = rt) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((e = Object.create(e)).wrapped = !0), this.elementProperties.set(t, e), !e.noAccessor) {
      const r = Symbol(), i = this.getPropertyDescriptor(t, r, e);
      i !== void 0 && _t(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, e, r) {
    const { get: i, set: n } = xt(this.prototype, t) ?? { get() {
      return this[e];
    }, set(a) {
      this[e] = a;
    } };
    return { get: i, set(a) {
      const d = i?.call(this);
      n?.call(this, a), this.requestUpdate(t, d, r);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? rt;
  }
  static _$Ei() {
    if (this.hasOwnProperty(A("elementProperties"))) return;
    const t = Ct(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(A("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(A("properties"))) {
      const e = this.properties, r = [...At(e), ...Et(e)];
      for (const i of r) this.createProperty(i, e[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [r, i] of e) this.elementProperties.set(r, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, r] of this.elementProperties) {
      const i = this._$Eu(e, r);
      i !== void 0 && this._$Eh.set(i, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const r = new Set(t.flat(1 / 0).reverse());
      for (const i of r) e.unshift(tt(i));
    } else t !== void 0 && e.push(tt(t));
    return e;
  }
  static _$Eu(t, e) {
    const r = e.attribute;
    return r === !1 ? void 0 : typeof r == "string" ? r : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise(((t) => this.enableUpdating = t)), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach(((t) => t(this)));
  }
  addController(t) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t), this.renderRoot !== void 0 && this.isConnected && t.hostConnected?.();
  }
  removeController(t) {
    this._$EO?.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const r of e.keys()) this.hasOwnProperty(r) && (t.set(r, this[r]), delete this[r]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return $t(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach(((t) => t.hostConnected?.()));
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    this._$EO?.forEach(((t) => t.hostDisconnected?.()));
  }
  attributeChangedCallback(t, e, r) {
    this._$AK(t, r);
  }
  _$ET(t, e) {
    const r = this.constructor.elementProperties.get(t), i = this.constructor._$Eu(t, r);
    if (i !== void 0 && r.reflect === !0) {
      const n = (r.converter?.toAttribute !== void 0 ? r.converter : O).toAttribute(e, r.type);
      this._$Em = t, n == null ? this.removeAttribute(i) : this.setAttribute(i, n), this._$Em = null;
    }
  }
  _$AK(t, e) {
    const r = this.constructor, i = r._$Eh.get(t);
    if (i !== void 0 && this._$Em !== i) {
      const n = r.getPropertyOptions(i), a = typeof n.converter == "function" ? { fromAttribute: n.converter } : n.converter?.fromAttribute !== void 0 ? n.converter : O;
      this._$Em = i;
      const d = a.fromAttribute(e, n.type);
      this[i] = d ?? this._$Ej?.get(i) ?? d, this._$Em = null;
    }
  }
  requestUpdate(t, e, r) {
    if (t !== void 0) {
      const i = this.constructor, n = this[t];
      if (r ??= i.getPropertyOptions(t), !((r.hasChanged ?? J)(n, e) || r.useDefault && r.reflect && n === this._$Ej?.get(t) && !this.hasAttribute(i._$Eu(t, r)))) return;
      this.C(t, e, r);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$EP());
  }
  C(t, e, { useDefault: r, reflect: i, wrapped: n }, a) {
    r && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t) && (this._$Ej.set(t, a ?? e ?? this[t]), n !== !0 || a !== void 0) || (this._$AL.has(t) || (this.hasUpdated || r || (e = void 0), this._$AL.set(t, e)), i === !0 && this._$Em !== t && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t));
  }
  async _$EP() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [i, n] of this._$Ep) this[i] = n;
        this._$Ep = void 0;
      }
      const r = this.constructor.elementProperties;
      if (r.size > 0) for (const [i, n] of r) {
        const { wrapped: a } = n, d = this[i];
        a !== !0 || this._$AL.has(i) || d === void 0 || this.C(i, void 0, n, d);
      }
    }
    let t = !1;
    const e = this._$AL;
    try {
      t = this.shouldUpdate(e), t ? (this.willUpdate(e), this._$EO?.forEach(((r) => r.hostUpdate?.())), this.update(e)) : this._$EM();
    } catch (r) {
      throw t = !1, this._$EM(), r;
    }
    t && this._$AE(e);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    this._$EO?.forEach(((e) => e.hostUpdated?.())), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Eq &&= this._$Eq.forEach(((e) => this._$ET(e, this[e]))), this._$EM();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
};
$.elementStyles = [], $.shadowRootOptions = { mode: "open" }, $[A("elementProperties")] = /* @__PURE__ */ new Map(), $[A("finalized")] = /* @__PURE__ */ new Map(), zt?.({ ReactiveElement: $ }), (N.reactiveElementVersions ??= []).push("2.1.1");
const K = globalThis, R = K.trustedTypes, ot = R ? R.createPolicy("lit-html", { createHTML: (o) => o }) : void 0, bt = "$lit$", f = `lit$${Math.random().toFixed(9).slice(2)}$`, ut = "?" + f, Pt = `<${ut}>`, w = document, S = () => w.createComment(""), z = (o) => o === null || typeof o != "object" && typeof o != "function", X = Array.isArray, Tt = (o) => X(o) || typeof o?.[Symbol.iterator] == "function", B = `[ 	
\f\r]`, x = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, it = /-->/g, nt = />/g, v = RegExp(`>|${B}(?:([^\\s"'>=/]+)(${B}*=${B}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), at = /'/g, st = /"/g, pt = /^(?:script|style|textarea|title)$/i, Ht = (o) => (t, ...e) => ({ _$litType$: o, strings: t, values: e }), m = Ht(1), g = Symbol.for("lit-noChange"), c = Symbol.for("lit-nothing"), dt = /* @__PURE__ */ new WeakMap(), k = w.createTreeWalker(w, 129);
function ft(o, t) {
  if (!X(o) || !o.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return ot !== void 0 ? ot.createHTML(t) : t;
}
const Mt = (o, t) => {
  const e = o.length - 1, r = [];
  let i, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", a = x;
  for (let d = 0; d < e; d++) {
    const s = o[d];
    let h, b, l = -1, u = 0;
    for (; u < s.length && (a.lastIndex = u, b = a.exec(s), b !== null); ) u = a.lastIndex, a === x ? b[1] === "!--" ? a = it : b[1] !== void 0 ? a = nt : b[2] !== void 0 ? (pt.test(b[2]) && (i = RegExp("</" + b[2], "g")), a = v) : b[3] !== void 0 && (a = v) : a === v ? b[0] === ">" ? (a = i ?? x, l = -1) : b[1] === void 0 ? l = -2 : (l = a.lastIndex - b[2].length, h = b[1], a = b[3] === void 0 ? v : b[3] === '"' ? st : at) : a === st || a === at ? a = v : a === it || a === nt ? a = x : (a = v, i = void 0);
    const p = a === v && o[d + 1].startsWith("/>") ? " " : "";
    n += a === x ? s + Pt : l >= 0 ? (r.push(h), s.slice(0, l) + bt + s.slice(l) + f + p) : s + f + (l === -2 ? d : p);
  }
  return [ft(o, n + (o[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), r];
};
class P {
  constructor({ strings: t, _$litType$: e }, r) {
    let i;
    this.parts = [];
    let n = 0, a = 0;
    const d = t.length - 1, s = this.parts, [h, b] = Mt(t, e);
    if (this.el = P.createElement(h, r), k.currentNode = this.el.content, e === 2 || e === 3) {
      const l = this.el.content.firstChild;
      l.replaceWith(...l.childNodes);
    }
    for (; (i = k.nextNode()) !== null && s.length < d; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const l of i.getAttributeNames()) if (l.endsWith(bt)) {
          const u = b[a++], p = i.getAttribute(l).split(f), H = /([.?@])?(.*)/.exec(u);
          s.push({ type: 1, index: n, name: H[2], strings: p, ctor: H[1] === "." ? Rt : H[1] === "?" ? Ut : H[1] === "@" ? Nt : L }), i.removeAttribute(l);
        } else l.startsWith(f) && (s.push({ type: 6, index: n }), i.removeAttribute(l));
        if (pt.test(i.tagName)) {
          const l = i.textContent.split(f), u = l.length - 1;
          if (u > 0) {
            i.textContent = R ? R.emptyScript : "";
            for (let p = 0; p < u; p++) i.append(l[p], S()), k.nextNode(), s.push({ type: 2, index: ++n });
            i.append(l[u], S());
          }
        }
      } else if (i.nodeType === 8) if (i.data === ut) s.push({ type: 2, index: n });
      else {
        let l = -1;
        for (; (l = i.data.indexOf(f, l + 1)) !== -1; ) s.push({ type: 7, index: n }), l += f.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const r = w.createElement("template");
    return r.innerHTML = t, r;
  }
}
function y(o, t, e = o, r) {
  if (t === g) return t;
  let i = r !== void 0 ? e._$Co?.[r] : e._$Cl;
  const n = z(t) ? void 0 : t._$litDirective$;
  return i?.constructor !== n && (i?._$AO?.(!1), n === void 0 ? i = void 0 : (i = new n(o), i._$AT(o, e, r)), r !== void 0 ? (e._$Co ??= [])[r] = i : e._$Cl = i), i !== void 0 && (t = y(o, i._$AS(o, t.values), i, r)), t;
}
class Ot {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: e }, parts: r } = this._$AD, i = (t?.creationScope ?? w).importNode(e, !0);
    k.currentNode = i;
    let n = k.nextNode(), a = 0, d = 0, s = r[0];
    for (; s !== void 0; ) {
      if (a === s.index) {
        let h;
        s.type === 2 ? h = new T(n, n.nextSibling, this, t) : s.type === 1 ? h = new s.ctor(n, s.name, s.strings, this, t) : s.type === 6 && (h = new Lt(n, this, t)), this._$AV.push(h), s = r[++d];
      }
      a !== s?.index && (n = k.nextNode(), a++);
    }
    return k.currentNode = w, i;
  }
  p(t) {
    let e = 0;
    for (const r of this._$AV) r !== void 0 && (r.strings !== void 0 ? (r._$AI(t, r, e), e += r.strings.length - 2) : r._$AI(t[e])), e++;
  }
}
class T {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t, e, r, i) {
    this.type = 2, this._$AH = c, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = r, this.options = i, this._$Cv = i?.isConnected ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && t?.nodeType === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = y(this, t, e), z(t) ? t === c || t == null || t === "" ? (this._$AH !== c && this._$AR(), this._$AH = c) : t !== this._$AH && t !== g && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Tt(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== c && z(this._$AH) ? this._$AA.nextSibling.data = t : this.T(w.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    const { values: e, _$litType$: r } = t, i = typeof r == "number" ? this._$AC(t) : (r.el === void 0 && (r.el = P.createElement(ft(r.h, r.h[0]), this.options)), r);
    if (this._$AH?._$AD === i) this._$AH.p(e);
    else {
      const n = new Ot(i, this), a = n.u(this.options);
      n.p(e), this.T(a), this._$AH = n;
    }
  }
  _$AC(t) {
    let e = dt.get(t.strings);
    return e === void 0 && dt.set(t.strings, e = new P(t)), e;
  }
  k(t) {
    X(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let r, i = 0;
    for (const n of t) i === e.length ? e.push(r = new T(this.O(S()), this.O(S()), this, this.options)) : r = e[i], r._$AI(n), i++;
    i < e.length && (this._$AR(r && r._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    for (this._$AP?.(!1, !0, e); t !== this._$AB; ) {
      const r = t.nextSibling;
      t.remove(), t = r;
    }
  }
  setConnected(t) {
    this._$AM === void 0 && (this._$Cv = t, this._$AP?.(t));
  }
}
class L {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, r, i, n) {
    this.type = 1, this._$AH = c, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = n, r.length > 2 || r[0] !== "" || r[1] !== "" ? (this._$AH = Array(r.length - 1).fill(new String()), this.strings = r) : this._$AH = c;
  }
  _$AI(t, e = this, r, i) {
    const n = this.strings;
    let a = !1;
    if (n === void 0) t = y(this, t, e, 0), a = !z(t) || t !== this._$AH && t !== g, a && (this._$AH = t);
    else {
      const d = t;
      let s, h;
      for (t = n[0], s = 0; s < n.length - 1; s++) h = y(this, d[r + s], e, s), h === g && (h = this._$AH[s]), a ||= !z(h) || h !== this._$AH[s], h === c ? t = c : t !== c && (t += (h ?? "") + n[s + 1]), this._$AH[s] = h;
    }
    a && !i && this.j(t);
  }
  j(t) {
    t === c ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class Rt extends L {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === c ? void 0 : t;
  }
}
class Ut extends L {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== c);
  }
}
class Nt extends L {
  constructor(t, e, r, i, n) {
    super(t, e, r, i, n), this.type = 5;
  }
  _$AI(t, e = this) {
    if ((t = y(this, t, e, 0) ?? c) === g) return;
    const r = this._$AH, i = t === c && r !== c || t.capture !== r.capture || t.once !== r.once || t.passive !== r.passive, n = t !== c && (r === c || i);
    i && this.element.removeEventListener(this.name, this, r), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    typeof this._$AH == "function" ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class Lt {
  constructor(t, e, r) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = r;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    y(this, t);
  }
}
const jt = K.litHtmlPolyfillSupport;
jt?.(P, T), (K.litHtmlVersions ??= []).push("3.3.1");
const Dt = (o, t, e) => {
  const r = e?.renderBefore ?? t;
  let i = r._$litPart$;
  if (i === void 0) {
    const n = e?.renderBefore ?? null;
    r._$litPart$ = i = new T(t.insertBefore(S(), n), n, void 0, e ?? {});
  }
  return i._$AI(o), i;
};
const Y = globalThis;
let E = class extends $ {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t.firstChild, t;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = Dt(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(!0);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(!1);
  }
  render() {
    return g;
  }
};
E._$litElement$ = !0, E.finalized = !0, Y.litElementHydrateSupport?.({ LitElement: E });
const Bt = Y.litElementPolyfillSupport;
Bt?.({ LitElement: E });
(Y.litElementVersions ??= []).push("4.2.1");
const It = { attribute: !0, type: String, converter: O, reflect: !1, hasChanged: J }, qt = (o = It, t, e) => {
  const { kind: r, metadata: i } = e;
  let n = globalThis.litPropertyMetadata.get(i);
  if (n === void 0 && globalThis.litPropertyMetadata.set(i, n = /* @__PURE__ */ new Map()), r === "setter" && ((o = Object.create(o)).wrapped = !0), n.set(e.name, o), r === "accessor") {
    const { name: a } = e;
    return { set(d) {
      const s = t.get.call(this);
      t.set.call(this, d), this.requestUpdate(a, s, o);
    }, init(d) {
      return d !== void 0 && this.C(a, void 0, o, d), d;
    } };
  }
  if (r === "setter") {
    const { name: a } = e;
    return function(d) {
      const s = this[a];
      t.call(this, d), this.requestUpdate(a, s, o);
    };
  }
  throw Error("Unsupported decorator location: " + r);
};
function j(o) {
  return (t, e) => typeof e == "object" ? qt(o, t, e) : ((r, i, n) => {
    const a = i.hasOwnProperty(n);
    return i.constructor.createProperty(n, r), a ? Object.getOwnPropertyDescriptor(i, n) : void 0;
  })(o, t, e);
}
const Gt = (o) => o.strings === void 0;
const vt = { CHILD: 2 }, kt = (o) => (...t) => ({ _$litDirective$: o, values: t });
class wt {
  constructor(t) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t, e, r) {
    this._$Ct = t, this._$AM = e, this._$Ci = r;
  }
  _$AS(t, e) {
    return this.update(t, e);
  }
  update(t, e) {
    return this.render(...e);
  }
}
const C = (o, t) => {
  const e = o._$AN;
  if (e === void 0) return !1;
  for (const r of e) r._$AO?.(t, !1), C(r, t);
  return !0;
}, U = (o) => {
  let t, e;
  do {
    if ((t = o._$AM) === void 0) break;
    e = t._$AN, e.delete(o), o = t;
  } while (e?.size === 0);
}, gt = (o) => {
  for (let t; t = o._$AM; o = t) {
    let e = t._$AN;
    if (e === void 0) t._$AN = e = /* @__PURE__ */ new Set();
    else if (e.has(o)) break;
    e.add(o), Ft(t);
  }
};
function Wt(o) {
  this._$AN !== void 0 ? (U(this), this._$AM = o, gt(this)) : this._$AM = o;
}
function Vt(o, t = !1, e = 0) {
  const r = this._$AH, i = this._$AN;
  if (i !== void 0 && i.size !== 0) if (t) if (Array.isArray(r)) for (let n = e; n < r.length; n++) C(r[n], !1), U(r[n]);
  else r != null && (C(r, !1), U(r));
  else C(this, o);
}
const Ft = (o) => {
  o.type == vt.CHILD && (o._$AP ??= Vt, o._$AQ ??= Wt);
};
class Jt extends wt {
  constructor() {
    super(...arguments), this._$AN = void 0;
  }
  _$AT(t, e, r) {
    super._$AT(t, e, r), gt(this), this.isConnected = t._$AU;
  }
  _$AO(t, e = !0) {
    t !== this.isConnected && (this.isConnected = t, t ? this.reconnected?.() : this.disconnected?.()), e && (C(this, t), U(this));
  }
  setValue(t) {
    if (Gt(this._$Ct)) this._$Ct._$AI(t, this);
    else {
      const e = [...this._$Ct._$AH];
      e[this._$Ci] = t, this._$Ct._$AI(e, this, 0);
    }
  }
  disconnected() {
  }
  reconnected() {
  }
}
const I = () => new Kt();
class Kt {
}
const q = /* @__PURE__ */ new WeakMap(), G = kt(class extends Jt {
  render(o) {
    return c;
  }
  update(o, [t]) {
    const e = t !== this.G;
    return e && this.G !== void 0 && this.rt(void 0), (e || this.lt !== this.ct) && (this.G = t, this.ht = o.options?.host, this.rt(this.ct = o.element)), c;
  }
  rt(o) {
    if (this.isConnected || (o = void 0), typeof this.G == "function") {
      const t = this.ht ?? globalThis;
      let e = q.get(t);
      e === void 0 && (e = /* @__PURE__ */ new WeakMap(), q.set(t, e)), e.get(this.G) !== void 0 && this.G.call(this.ht, void 0), e.set(this.G, o), o !== void 0 && this.G.call(this.ht, o);
    } else this.G.value = o;
  }
  get lt() {
    return typeof this.G == "function" ? q.get(this.ht ?? globalThis)?.get(this.G) : this.G?.value;
  }
  disconnected() {
    this.lt === this.ct && this.rt(void 0);
  }
  reconnected() {
    this.rt(this.ct);
  }
});
class W extends wt {
  constructor(t) {
    if (super(t), this.it = c, t.type !== vt.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(t) {
    if (t === c || t == null) return this._t = void 0, this.it = t;
    if (t === g) return t;
    if (typeof t != "string") throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (t === this.it) return this._t;
    this.it = t;
    const e = [t];
    return e.raw = e, this._t = { _$litType$: this.constructor.resultType, strings: e, values: [] };
  }
}
W.directiveName = "unsafeHTML", W.resultType = 1;
const Xt = kt(W), Yt = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="o-ic-24_close"><path d="M18.3628 5.63727 5.63733 18.3627m12.72547.0L5.63733 5.63727" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="square"/></svg>', Zt = '@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000}}}@layer base{*,:after,:before{box-sizing:border-box;border:0;margin:0;padding:0}html{-webkit-text-size-adjust:100%;tab-size:4;-webkit-font-feature-settings:normal;font-feature-settings:normal;font-variation-settings:normal;font-family:Helvetica,Arial,sans-serif;line-height:1.5}body{line-height:inherit;margin:0}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){border-bottom:none;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:500}code,kbd,pre,samp{font-family:monospace;font-size:1em}small{font-size:80%}sub,sup{vertical-align:initial;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:initial;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:initial}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre,fieldset{margin:0}fieldset,legend{padding:0}menu,ol,ul{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::-webkit-input-placeholder{opacity:1;color:#6c6765}textarea::-webkit-input-placeholder{opacity:1;color:#6c6765}:is(input:-ms-placeholder-shown,textarea:-ms-placeholder-shown),:is(input:placeholder-shown,textarea:placeholder-shown){opacity:1;color:#6c6765}input::-moz-placeholder{opacity:1;color:#6c6765}textarea::-moz-placeholder{opacity:1;color:#6c6765}input::placeholder,textarea::placeholder{opacity:1;color:#6c6765}[role=button],button{cursor:pointer;color:inherit}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}template,[hidden]{display:none}}.visible{visibility:visible}.sr-only{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}.fixed{position:fixed}.relative{position:relative}.static{position:static}.inset-0{inset:var(--bdk-space-0,0rem)}.z-10{z-index:10}.z-20{z-index:20}.mb-2{margin-bottom:var(--bdk-space-2,1.33333rem)}.bdk-tw-button-icon{--bdk-button-icon-size-extra-extra-small:var(--bdk-space-6,4rem);--bdk-button-icon-size-extra-small:var(--bdk-space-8,5.33333rem);--bdk-button-icon-size-small:var(--bdk-space-11,7.33333rem);--bdk-button-icon-size-medium:var(--bdk-space-14,9.33333rem);--bdk-button-icon-size-large:var(--bdk-space-16,10.6667rem);--bdk-button-icon-stroke-width-extra-extra-small:1;--bdk-button-icon-stroke-width-extra-small:1.25;--bdk-button-icon-stroke-width-small:1.5;--bdk-button-icon-stroke-width-medium:1.75;--bdk-button-icon-stroke-width-large:2;--bdk-button-icon-radius-pill:var(--bdk-radius-pill,166.5rem);--bdk-button-icon-radius-rounded:var(--bdk-radius-2,1.33333rem);--bdk-button-icon-radius:var(--bdk-button-icon-radius-rounded);--bdk-button-icon-default-border-width:1px;--bdk-button-icon-just-icon-border-width:0px;--bdk-button-icon-border-width:var(--bdk-button-icon-default-border-width);width:var(--bdk-button-icon-size);aspect-ratio:1;border-width:var(--bdk-button-icon-border-width);text-align:center;cursor:pointer;border-radius:var(--bdk-button-icon-radius);transition:background-color var(--bdk-transition-duration-default,.2s)ease,color var(--bdk-transition-duration-default,.2s)ease,border-color var(--bdk-transition-duration-default,.2s)ease;border-style:solid;justify-content:center;align-items:center;display:inline-flex}.block{display:block}.flex{display:flex}.h-\\[800px\\]{height:800px}.h-full{height:100%}.w-full{width:100%}.bdk-tw-button-icon[variant=primary]:disabled{cursor:auto;background-color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=primary]:disabled{background-color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=primary]:disabled{color:var(--bdk-snow-100,#fff);border-color:#0000}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=primary]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=highlight]:disabled{cursor:auto;background-color:var(--bdk-red-hover-light,#cb0d33);border-color:var(--bdk-red-hover-light,#cb0d33);color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=highlight]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=highlight][inverted]:disabled{cursor:auto;background-color:var(--bdk-red-hover-light,#cb0d33);border-color:var(--bdk-red-hover-light,#cb0d33);color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=highlight][inverted]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=outline]:disabled{cursor:auto;border-color:var(--bdk-coal-100,#1a1a1a);background-color:#0000}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=outline]:disabled{border-color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=outline]:disabled{color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=outline]:disabled{color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=outline][inverted]:disabled{cursor:auto;border-color:var(--bdk-snow-100,#fff);background-color:#0000}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=outline][inverted]:disabled{border-color:color-mix(in srgb,var(--bdk-snow-100,#fff)25%,transparent)}}.bdk-tw-button-icon[variant=outline][inverted]:disabled{color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=outline][inverted]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)25%,transparent)}}.bdk-tw-button-icon[variant=overlay-neutral]:disabled{cursor:auto;background-color:var(--bdk-alabaster,#faf8f7);border-color:var(--bdk-alabaster,#faf8f7);color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-neutral]:disabled{color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=overlay-light]:disabled{cursor:auto;background-color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-light]:disabled{background-color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=overlay-light]:disabled{color:var(--bdk-coal-100,#1a1a1a);border-color:#0000}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-light]:disabled{color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=overlay-dark]:disabled{cursor:auto;background-color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-dark]:disabled{background-color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=overlay-dark]:disabled{color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-dark]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=just-icon]:disabled{cursor:auto;color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=just-icon]:disabled{color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)25%,transparent)}}.bdk-tw-button-icon[variant=just-icon][inverted]:disabled{cursor:auto;color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=just-icon][inverted]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)25%,transparent)}}.items-center{align-items:center}.justify-center{justify-content:center}.overflow-hidden{overflow:hidden}.bdk-tw-button-icon[variant=primary]{background-color:var(--bdk-coal-100,#1a1a1a);border-color:var(--bdk-coal-100,#1a1a1a);color:var(--bdk-snow-100,#fff)}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=primary]:hover{background-color:var(--bdk-red-hover-light,#cb0d33);border-color:var(--bdk-red-hover-light,#cb0d33);color:var(--bdk-snow-100,#fff)}}.bdk-tw-button-icon[variant=primary][inverted]{background-color:var(--bdk-snow-100,#fff);border-color:var(--bdk-snow-100,#fff);color:var(--bdk-coal-100,#1a1a1a)}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=primary][inverted]:hover{background-color:var(--bdk-red-hover-light,#cb0d33);border-color:var(--bdk-red-hover-light,#cb0d33);color:var(--bdk-snow-100,#fff)}}.bdk-tw-button-icon[variant=primary][inverted]:disabled{color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=primary][inverted]:disabled{color:color-mix(in srgb,var(--bdk-snow-100,#fff)25%,transparent)}}.bdk-tw-button-icon[variant=primary][inverted]:disabled{background-color:#ffffff40;border-color:#0000}.bdk-tw-button-icon[variant=highlight]{background-color:var(--bdk-red-hover-light,#cb0d33);border-color:var(--bdk-red-hover-light,#cb0d33);color:var(--bdk-snow-100,#fff)}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=highlight][inverted]:hover{background-color:var(--bdk-snow-100,#fff);border-color:var(--bdk-snow-100,#fff);color:var(--bdk-coal-100,#1a1a1a)}}.bdk-tw-button-icon[variant=outline]{border-color:var(--bdk-coal-100,#1a1a1a);color:var(--bdk-coal-100,#1a1a1a);background-color:#0000}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=outline]:hover{background-color:var(--bdk-coal-100,#1a1a1a);border-color:var(--bdk-coal-100,#1a1a1a);color:var(--bdk-snow-100,#fff)}}.bdk-tw-button-icon[variant=outline][inverted]{border-color:var(--bdk-snow-100,#fff);color:var(--bdk-snow-100,#fff);background-color:#0000}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=outline][inverted]:hover{background-color:var(--bdk-snow-100,#fff);border-color:var(--bdk-snow-100,#fff);color:var(--bdk-coal-100,#1a1a1a)}}.bdk-tw-button-icon[variant=overlay-neutral]{background-color:var(--bdk-concrete,#f4f2f2);border-color:var(--bdk-concrete,#f4f2f2);color:var(--bdk-coal-100,#1a1a1a)}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=overlay-neutral]:hover{background-color:var(--bdk-coal-100,#1a1a1a);border-color:var(--bdk-coal-100,#1a1a1a);color:var(--bdk-snow-100,#fff)}}.bdk-tw-button-icon[variant=overlay-light]{background-color:var(--bdk-snow-100,#fff)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-light]{background-color:color-mix(in srgb,var(--bdk-snow-100,#fff)50%,transparent)}}.bdk-tw-button-icon[variant=overlay-light]{color:var(--bdk-coal-100,#1a1a1a);border-color:#0000}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=overlay-light]:hover{background-color:var(--bdk-coal-100,#1a1a1a);border-color:var(--bdk-coal-100,#1a1a1a);color:var(--bdk-snow-100,#fff)}}.bdk-tw-button-icon[variant=overlay-dark]{background-color:var(--bdk-coal-100,#1a1a1a)}@supports (color:color-mix(in lab,red,red)){.bdk-tw-button-icon[variant=overlay-dark]{background-color:color-mix(in srgb,var(--bdk-coal-100,#1a1a1a)50%,transparent)}}.bdk-tw-button-icon[variant=overlay-dark]{color:var(--bdk-snow-100,#fff);border-color:#0000}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=highlight]:hover{background-color:var(--bdk-coal-100,#1a1a1a);border-color:var(--bdk-coal-100,#1a1a1a)}.bdk-tw-button-icon[variant=overlay-dark]:hover{background-color:var(--bdk-snow-100,#fff);color:var(--bdk-coal-100,#1a1a1a)}}.bdk-tw-button-icon[variant=just-icon]{--bdk-button-icon-border-width:var(--bdk-button-icon-just-icon-border-width);background-color:#0000}.bdk-tw-button-icon svg path{stroke-width:var(--bdk-button-icon-stroke-width)}.bdk-tw-button-icon[size=extra-extra-small]{--bdk-button-icon-size:var(--bdk-button-icon-size-extra-extra-small);--bdk-button-icon-stroke-width:var(--bdk-button-icon-stroke-width-extra-extra-small);font-family:var(--bdk-button-s-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-button-s-font-size,2rem);font-weight:var(--bdk-button-s-font-weight,500);letter-spacing:var(--bdk-button-s-letter-spacing,.033333rem);line-height:var(--bdk-button-s-line-height,3rem);-webkit-text-decoration:var(--bdk-button-s-text-decoration,none);text-decoration:var(--bdk-button-s-text-decoration,none);text-transform:var(--bdk-button-s-text-transform,uppercase)}.bdk-tw-button-icon[size=extra-small]{--bdk-button-icon-size:var(--bdk-button-icon-size-extra-small);--bdk-button-icon-stroke-width:var(--bdk-button-icon-stroke-width-extra-small);font-family:var(--bdk-button-s-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-button-s-font-size,2rem);font-weight:var(--bdk-button-s-font-weight,500);letter-spacing:var(--bdk-button-s-letter-spacing,.033333rem);line-height:var(--bdk-button-s-line-height,3rem);-webkit-text-decoration:var(--bdk-button-s-text-decoration,none);text-decoration:var(--bdk-button-s-text-decoration,none);text-transform:var(--bdk-button-s-text-transform,uppercase)}.bdk-tw-button-icon[size=small]{--bdk-button-icon-size:var(--bdk-button-icon-size-small);--bdk-button-icon-stroke-width:var(--bdk-button-icon-stroke-width-small);font-family:var(--bdk-button-s-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-button-s-font-size,2rem);font-weight:var(--bdk-button-s-font-weight,500);letter-spacing:var(--bdk-button-s-letter-spacing,.033333rem);line-height:var(--bdk-button-s-line-height,3rem);-webkit-text-decoration:var(--bdk-button-s-text-decoration,none);text-decoration:var(--bdk-button-s-text-decoration,none);text-transform:var(--bdk-button-s-text-transform,uppercase)}.bdk-tw-button-icon[size=medium]{--bdk-button-icon-size:var(--bdk-button-icon-size-medium);--bdk-button-icon-stroke-width:var(--bdk-button-icon-stroke-width-medium);font-family:var(--bdk-button-m-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-button-m-font-size,2.33333rem);font-weight:var(--bdk-button-m-font-weight,500);letter-spacing:var(--bdk-button-m-letter-spacing,.033333rem);line-height:var(--bdk-button-m-line-height,3.66667rem);-webkit-text-decoration:var(--bdk-button-m-text-decoration,none);text-decoration:var(--bdk-button-m-text-decoration,none);text-transform:var(--bdk-button-m-text-transform,uppercase)}.bdk-tw-button-icon[size=large]{--bdk-button-icon-size:var(--bdk-button-icon-size-large);--bdk-button-icon-stroke-width:var(--bdk-button-icon-stroke-width-large);font-family:var(--bdk-button-l-font-family,"Eduard Breuninger",Helvetica,Arial,sans-serif);font-size:var(--bdk-button-l-font-size,2.66667rem);font-weight:var(--bdk-button-l-font-weight,500);letter-spacing:var(--bdk-button-l-letter-spacing,.05rem);line-height:var(--bdk-button-l-line-height,4rem);-webkit-text-decoration:var(--bdk-button-l-text-decoration,none);text-decoration:var(--bdk-button-l-text-decoration,none);text-transform:var(--bdk-button-l-text-transform,uppercase)}.bdk-tw-heading-m{letter-spacing:.083333rem;text-transform:uppercase;font-family:Eduard Breuninger;font-size:3.33333rem;font-weight:500;line-height:5rem}.bdk-tw-button-icon[variant=just-icon][inverted]{--bdk-button-icon-border-width:var(--bdk-button-icon-just-icon-border-width);color:var(--bdk-snow-100,#fff)}@media screen and (pointer:fine){.bdk-tw-button-icon[variant=just-icon]:hover,.bdk-tw-button-icon[variant=just-icon][inverted]:hover{color:var(--bdk-red-hover-light,#cb0d33)}}.shadow{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.bdk-tw-button-icon:not(:disabled):focus-visible{outline:2px solid var(--bdk-focus-color);outline-offset:2px;box-shadow:0 0 0 3px var(--bdk-focus-background-color)}.bdk-tw-button-icon:not(:disabled)[inverted]:focus-visible{outline:2px solid var(--bdk-focus-color-inverted);outline-offset:2px;box-shadow:0 0 0 3px var(--bdk-focus-background-color-inverted)}@media(prefers-reduced-motion:reduce){.bdk-tw-button-icon{transition:none}}.bdk-tw-button-icon[circle]{--bdk-button-icon-radius:var(--bdk-button-icon-radius-pill)}dialog{--bdk-drawer-min-width:100%;--bdk-drawer-min-height:240px;--bdk-drawer-max-height:calc(100dvh - var(--bdk-drawer-margin-block-start));--bdk-drawer-margin-block-start:var(--bdk-space-10);--bdk-drawer-padding-inline:var(--bdk-space-5);--bdk-drawer-transform:translate3d(0,100%,0);--bdk-drawer-starting-transform:translate3d(0,100%,0);min-width:var(--bdk-drawer-min-width);min-height:var(--bdk-drawer-min-height);max-height:var(--bdk-drawer-max-height);background-color:var(--bdk-snow-100);transform:var(--bdk-drawer-transform);transition:display var(--bdk-transition-duration-default)allow-discrete,overlay var(--bdk-transition-duration-default)allow-discrete,transform var(--bdk-transition-duration-default)ease-out;flex-direction:column;display:none;inset:auto 0 0}dialog[open]{--bdk-drawer-transform:translate3d(0,0,0);display:flex}@starting-style{dialog[open]{transform:var(--bdk-drawer-starting-transform)}}.drawer-header{width:100%;padding-block-end:var(--bdk-space-6)}.drawer-header-bar{margin:var(--bdk-space-2);justify-content:space-between;align-items:center;display:flex}.drawer-title,.drawer-content,.drawer-footer{padding-inline:var(--bdk-drawer-padding-inline)}.drawer-header-content{gap:var(--bdk-space-4);grid-template-columns:min-content auto min-content;align-items:center;display:grid}.drawer-content{flex:1;padding-block-end:var(--bdk-space-10);overflow:auto}.drawer-footer{isolation:isolate;padding-block-start:var(--bdk-space-4);padding-block-end:var(--bdk-space-8)}dialog:has(.drawer-title) .drawer-header-content{margin-block-end:var(--bdk-space-4)}dialog::backdrop{background-color:var(--bdk-backdrop-layer,#1a1a1a80);opacity:0;transition:opacity var(--bdk-transition-duration-default)ease-out;position:fixed;inset:0}dialog[open]::backdrop{opacity:1}@starting-style{dialog[open]::backdrop{opacity:0}}@media(prefers-reduced-motion:reduce){dialog,dialog::backdrop{transition:none}}@media screen and (max-width:759px){dialog{border-radius:var(--bdk-space-3)var(--bdk-space-3)0 0;height:auto}:host([full-screen]) dialog{--bdk-drawer-min-height:100dvh;border-radius:0}}@media screen and (min-width:760px){dialog{--bdk-drawer-min-width:360px;--bdk-drawer-margin-block-start:0;--bdk-drawer-transform:translate3d(100%,0,0);--bdk-drawer-starting-transform:translate3d(100%,0,0);--bdk-drawer-padding-inline:var(--bdk-space-10);width:33.3vw;height:100dvh;top:0;left:auto}.drawer-header-bar{margin:var(--bdk-space-1)var(--bdk-space-1)var(--bdk-space-1)var(--bdk-space-6)}}@media screen and (min-width:1920px){dialog{--bdk-drawer-min-width:556px}}@property --tw-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:"*";inherits:false}@property --tw-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:"*";inherits:false}@property --tw-inset-shadow-alpha{syntax:"<percentage>";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:"*";inherits:false}@property --tw-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:"*";inherits:false}@property --tw-inset-ring-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:"*";inherits:false}@property --tw-ring-offset-width{syntax:"<length>";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:"*";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:"*";inherits:false;initial-value:0 0 #0000}';
const lt = (o) => o ?? c;
var Qt = Object.defineProperty, D = (o, t, e, r) => {
  for (var i = void 0, n = o.length - 1, a; n >= 0; n--)
    (a = o[n]) && (i = a(t, e, i) || i);
  return i && Qt(t, e, i), i;
};
const te = "drawer:open", ee = "drawer:close", Z = class Z extends E {
  constructor() {
    super(...arguments), this.drawerRef = I(), this.drawerHeaderRef = I(), this.drawerFooterRef = I(), this.triggerElement = null, this.id = "", this.open = !1, this.fullScreen = !1, this.closeAriaLabel = "Close";
  }
  connectedCallback() {
    super.connectedCallback(), this.handleOutsideClick = this.handleOutsideClick.bind(this), this.onClose = this.onClose.bind(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), document.body.inert = !1, this.drawerRef.value?.removeEventListener("click", this.handleOutsideClick), this.drawerRef.value?.removeEventListener("close", this.onClose);
  }
  attributeChangedCallback(t, e, r) {
    super.attributeChangedCallback(t, e, r), t === "open" && (r !== null ? this.show() : this.hide());
  }
  firstUpdated() {
    this.drawerRef.value && this.drawerRef.value.addEventListener("close", this.onClose);
  }
  get eventPrefix() {
    return this.id ? `${this.id}-` : "";
  }
  dispatchOpenEvent() {
    const t = new CustomEvent(`${this.eventPrefix}${te}`, {
      bubbles: !0
    });
    this.dispatchEvent(t);
  }
  dispatchCloseEvent() {
    const t = new CustomEvent(`${this.eventPrefix}${ee}`, {
      bubbles: !0,
      composed: !0
    });
    this.dispatchEvent(t);
  }
  handleOutsideClick(t) {
    const e = t.target;
    if (e.tagName !== "DIALOG")
      return;
    const r = e.getBoundingClientRect();
    r.top <= t.clientY && t.clientY <= r.top + r.height && r.left <= t.clientX && t.clientX <= r.left + r.width || this.hide();
  }
  show() {
    this.triggerElement ??= document.activeElement instanceof HTMLElement ? document.activeElement : null, document.body.inert = !0, this.open = !0, this.drawerRef.value?.showModal(), this.drawerRef.value?.addEventListener("click", this.handleOutsideClick), this.dispatchOpenEvent();
  }
  async hide() {
    this.drawerRef.value?.close();
  }
  /**
   * @description
   * Closes all open drawers on the page.
   * Note: Does not close nested drawers in shadow roots.
   */
  closeAll() {
    document.querySelectorAll("bdk-drawer[open]").forEach((e) => {
      try {
        e.hide();
      } catch (r) {
        console.error("Failed to hide bdk-drawer:", e, r);
      }
    });
  }
  onClose() {
    this.open = !1, document.body.inert = !1, this.drawerRef.value?.removeEventListener("click", this.handleOutsideClick), this.dispatchCloseEvent(), setTimeout(() => {
      this.triggerElement?.focus();
    }, 20);
  }
  render() {
    return m`<dialog id="drawer" class="drawer" ${G(this.drawerRef)} aria-labelledby="${lt(
      this.hasTitle() ? "drawer-title" : void 0
    )}" aria-describedby="${lt(
      this.hasDescription() ? "drawer-description" : void 0
    )}" aria-modal="true" data-testid="${this.id}-drawer">${this.headerHTML()} ${this.bodyHTML()} ${this.footerHTML()}</dialog>`;
  }
  headerHTML() {
    return m`<div id="drawer-header" ${G(this.drawerHeaderRef)} class="drawer-header">${this.headerBarHTML()} ${this.titleHTML()}<div id="drawer-description" class="sr-only"><slot name="description"></slot></div></div>`;
  }
  headerBarHTML() {
    return m`<div class="drawer-header-bar"><div><slot name="header-start"></slot></div><button @click="${this.hide}" class="bdk-tw-button-icon" variant="just-icon" size="small" type="button" data-testid="bdk-drawer-close-button" aria-label="${this.closeAriaLabel}"><span role="presentation">${Xt(Yt)}</span></button></div>`;
  }
  titleHTML() {
    if (this.hasTitle())
      return m`<div class="drawer-title bdk-tw-heading-m text-coal" id="drawer-title"><slot name="title"></slot></div>`;
  }
  bodyHTML() {
    return m`<div id="drawer-content" class="drawer-content"><slot></slot></div>`;
  }
  footerHTML() {
    if (this.querySelector('[slot="footer"]') !== null)
      return m`<div class="drawer-footer" ${G(this.drawerFooterRef)}><slot name="footer"></slot></div>`;
  }
  hasTitle() {
    return this.querySelector('[slot="title"]') !== null;
  }
  hasDescription() {
    return this.querySelector('[slot="description"]') !== null;
  }
};
Z.styles = mt`${ht(Zt)}`;
let _ = Z;
D([
  j({ type: String })
], _.prototype, "id");
D([
  j({ type: Boolean, reflect: !0 })
], _.prototype, "open");
D([
  j({ type: Boolean, reflect: !0, attribute: "full-screen" })
], _.prototype, "fullScreen");
D([
  j({ type: String, reflect: !0, attribute: "close-aria-label" })
], _.prototype, "closeAriaLabel");
export {
  _ as Drawer
};
